function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.33333 4.40003V12.4H4V4.40003H1.33333ZM0 3.73336L2.66667 0.400024L5.33333 3.73336V13.7334H0V3.73336ZM10.6667 9.73336V8.40003H8.66667V7.06669H10.6667V5.73336H9.33333V4.40003H10.6667V3.06669H8V12.4H10.6667V11.0667H9.33333V9.73336H10.6667ZM7.33333 1.73336H11.3333C11.5101 1.73336 11.6797 1.8036 11.8047 1.92862C11.9298 2.05364 12 2.22321 12 2.40002V13.0667C12 13.2435 11.9298 13.4131 11.8047 13.5381C11.6797 13.6631 11.5101 13.7334 11.3333 13.7334H7.33333C7.15652 13.7334 6.98695 13.6631 6.86193 13.5381C6.73691 13.4131 6.66667 13.2435 6.66667 13.0667V2.40002C6.66667 2.22321 6.73691 2.05364 6.86193 1.92862C6.98695 1.8036 7.15652 1.73336 7.33333 1.73336Z",
  fill: "#121221"
});

function SvgFashionDesigningTiny(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFashionDesigningTiny);
export default __webpack_public_path__ + "static/media/FashionDesigningTiny.58b40b25.svg";
export { ForwardRef as ReactComponent };